import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c83abe6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "circular-border" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "subtitle" }, "Transações", -1))
const _hoisted_4 = { class: "history-segments" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "transactions" }
const _hoisted_7 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderWallet = _resolveComponent("HeaderWallet")!
  const _component_transactions_list_skeleton = _resolveComponent("transactions-list-skeleton")!
  const _component_TransactionCashBackCard = _resolveComponent("TransactionCashBackCard")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_HeaderWallet, {
            title: "Seu saldo",
            "cash-back-value": $setup.cashbackValue,
            history: false
          }, null, 8, ["cash-back-value"]),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("div", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterSegments, (segment) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: segment.name,
                    class: _normalizeClass({ active: _ctx.currentSegment == segment.value }),
                    onClick: ($event: any) => ($options.filterTransactionsBySegment(segment.value))
                  }, [
                    _createElementVNode("p", null, _toDisplayString(segment.name), 1)
                  ], 10, _hoisted_5))
                }), 128))
              ]),
              ($setup.loadingRef)
                ? (_openBlock(), _createBlock(_component_transactions_list_skeleton, { key: 0 }))
                : _createCommentVNode("", true),
              _createVNode(_component_ion_list, null, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.segmentTransactionsRef, (transaction) => {
                    return (_openBlock(), _createBlock(_component_ion_item, {
                      key: transaction.id,
                      class: "no-padding"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_6, [
                          _createVNode(_component_TransactionCashBackCard, { transaction: transaction }, null, 8, ["transaction"])
                        ])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }),
              ($setup.transactionsDataRef.length == 0 && !$setup.loadingRef)
                ? (_openBlock(), _createElementBlock("p", _hoisted_7, " Nenhuma transação encontrada :( "))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}